import Server from './server';
import Client from './client';

const Windows = [
    ...Server,
    ...Client,
];

export default Windows;